/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_join_community_of_over_1_000_000_people_we_ve_been_empowering_since_1991: Phrase =locale => {
  const en = `Join the community of over 1,000,000 people we’ve been empowering since 1991.`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Únete a nuestra comunidad de más de 1,000,000 personas a las que hemos estado ayudando desde 1991.`,
  };
  return phrases[locale] || en;
};
            